"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var TealiumHelper = /** @class */ (function () {
    function TealiumHelper(teamliumOptions) {
        var _this = this;
        this.ignoreKey = function (key) {
            var shouldIgnoreKey = 0;
            // Build a new array to avoid running through Object.keys multiple times
            if (typeof _this.ignoreKeysList === 'undefined') {
                _this.ignoreKeysList = Object.keys(_this.teamliumOptions.ignoreKeys);
                _this.ignoreKeysList.forEach(function (name) {
                    // Store a copy of the regex in the object
                    _this.teamliumOptions.ignoreKeys[name] = new RegExp('^' + name);
                    if (key.match(_this.teamliumOptions.ignoreKeys[name])) {
                        shouldIgnoreKey = 1;
                    }
                });
            }
            else {
                // Loop through the ignore_keys object to see if we should ignore this key
                _this.ignoreKeysList.forEach(function (name) {
                    if (key.match(_this.teamliumOptions.ignoreKeys[name])) {
                        shouldIgnoreKey = 1;
                    }
                });
            }
            return shouldIgnoreKey;
        };
        this.getKeyName = function (key) {
            // Create a new object to store regexs or use existing one
            _this.replaceKeysRegex = _this.replaceKeysRegex || {};
            // Build a new array to avoid running through Object.keys multiple times
            if (typeof _this.replaceKeysList === 'undefined') {
                _this.replaceKeysList = Object.keys(_this.teamliumOptions.replaceKeys);
                // Make a start of string and end of string regex
                _this.replaceKeysRegex.startOfString = new RegExp('^[' + _this.teamliumOptions.nestedDelimiter + ']');
                _this.replaceKeysRegex.endOfString = new RegExp('[' + _this.teamliumOptions.nestedDelimiter + ']$');
                _this.replaceKeysList.forEach(function (name) {
                    // Store a copy of the regex in the this.replaceKeysRegex object so that the regexs are only built once
                    _this.replaceKeysRegex[name] = new RegExp('[' + _this.teamliumOptions.nestedDelimiter + ']?' + name + '[' + _this.teamliumOptions.nestedDelimiter + ']?', 'g');
                    key = _this.keyReplace(key, name, _this.replaceKeysRegex[name]);
                });
            }
            else {
                // Loop through the replace_keys object to see what we should be replacing
                _this.replaceKeysList.forEach(function (name) {
                    key = _this.keyReplace(key, name, _this.replaceKeysRegex[name]);
                });
            }
            return key;
        };
        this.keyReplace = function (key, name, re) {
            // Check to see if we are replacing the key name with a new value or if we are removing the key altogether
            if (_this.teamliumOptions.replaceKeys[name] === '') {
                // The key needs to be removed completely
                key = key.replace(re, _this.teamliumOptions.nestedDelimiter);
                // Check to see if the key starts with the nested delimiter and if so, remove it
                if (key.indexOf(_this.teamliumOptions.nestedDelimiter) === 0) {
                    var cleanRegEx = new RegExp('^[' + _this.teamliumOptions.nestedDelimiter + ']');
                    key = key.replace(cleanRegEx, '');
                }
            }
            else {
                // Make a copy of the original key to see how we need to update the key name
                var origKey = key;
                // Replace the key name
                key = key.replace(re, _this.teamliumOptions.nestedDelimiter + _this.teamliumOptions.replaceKeys[name] + _this.teamliumOptions.nestedDelimiter);
                // Check for the start of the origKey to see of the nested delimiter is there
                if (!origKey.match(_this.replaceKeysRegex.startOfString)) {
                    // Remove the nested delimiter from the start of the string
                    var cleanRegEx = new RegExp('^[' + _this.teamliumOptions.nestedDelimiter + ']');
                    key = key.replace(cleanRegEx, '');
                }
                // Check for the end of the origKey to see of the nested delimiter is there
                if (!origKey.match(_this.replaceKeysRegex.endOfString)) {
                    // Add the nested delimiter to the end of the string
                    var cleanRegEx = new RegExp('[' + _this.teamliumOptions.nestedDelimiter + ']$');
                    key = key.replace(cleanRegEx, '');
                }
            }
            return key;
        };
        this.processDataObject = function (obj, newObj, parentKey, createArray) {
            if (typeof parentKey === 'undefined') {
                // This object isn't nested in another object
                parentKey = '';
            }
            else {
                // Add the nested_delimiter to the parent key if the delimiter isn't already at the end
                _this.nestedDelimiterRegex = _this.nestedDelimiterRegex || new RegExp('[' + _this.teamliumOptions.nestedDelimiter + ']$');
                if (!parentKey.match(_this.nestedDelimiterRegex)) {
                    parentKey += '' + _this.teamliumOptions.nestedDelimiter;
                }
            }
            Object.keys(obj).forEach(function (key) {
                var nestedKeyName = parentKey + key;
                // Format the new key name and take out any whitespace
                var newKeyName = _this.getKeyName((_this.teamliumOptions.prefix + parentKey + key).replace(/\s/g, ''));
                // Set the keyType to limit the number of typeof checks
                var keyType = _this.typeOf(obj[key]);
                if (keyType !== 'undefined' && keyType != null) {
                    if (keyType.match(/boolean|string|number|date/) && !_this.ignoreKey(key)) {
                        // If obj[key] is a date, convert to ISOString
                        if (_this.typeOf(obj[key]) === 'date') {
                            obj[key] = obj[key].toISOString();
                        }
                        // Check to see if we need to create an array for this data point
                        if (createArray) {
                            // First check to see if this key exists
                            if (_this.typeOf(newObj[newKeyName]) !== 'array') {
                                // Make the key an array
                                newObj[newKeyName] = [];
                            }
                            newObj[newKeyName].push('' + obj[key]); // Force value to be a string
                        }
                        else {
                            // If the value of the key is a boolean or a string or a number and
                            // the key shouldn't be ignored add to the data layer
                            newObj[newKeyName] = '' + obj[key]; // Force value to be a string
                        }
                    }
                    else if (keyType === 'object' && !_this.ignoreKey(key)) {
                        // Process this piece of the data layer and merge it
                        _this.processDataObject(obj[key], newObj, nestedKeyName, createArray);
                    }
                    else if (keyType === 'array') {
                        _this.processDataArray(obj[key], newObj, nestedKeyName);
                    }
                }
            });
        };
        this.processDataArray = function (obj, newObj, parentKey) {
            var objLength = obj.length;
            if (typeof parentKey === 'undefined') {
                // This object isn't nested in another object
                parentKey = '';
            }
            else if (objLength > 0 && _this.typeOf(obj[0]).match(/boolean|string|number|date/)) {
                // This is a normal array that doesn't need a nested delimiter
            }
            else {
                // Add the nested_delimiter to the parent key
                parentKey += '' + _this.teamliumOptions.nestedDelimiter;
            }
            // Format the new key name and take out any whitespace
            var newKeyName = _this.getKeyName((_this.teamliumOptions.prefix + parentKey).replace(/\s/g, ''));
            for (var n = 0; n < objLength; n++) {
                var keyType = _this.typeOf(obj[n]);
                if (keyType.match(/boolean|string|number|date/)) {
                    // If obj[n] is a date, convert to ISOString
                    if (keyType === 'date') {
                        obj[n] = obj[n].toISOString();
                    }
                    // First check to see if this key exists
                    if (_this.typeOf(newObj[newKeyName]) !== 'array') {
                        // Make the key an array
                        newObj[newKeyName] = [];
                    }
                    // If the value of the key is a boolean or a string or a number and
                    // the key shouldn't be ignored add to the data layer
                    newObj[newKeyName].push('' + obj[n]);
                }
                else if (keyType === 'object') {
                    _this.processDataObject(obj[n], newObj, newKeyName, 1);
                }
            }
        };
        this.typeOf = function (e) {
            return ({}).toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
        };
        this.flattenObject = function (obj, newObj) {
            // Make sure object exists
            if (typeof obj === 'undefined') {
                return false;
            }
            // Check to see if we want to flatten the same object and keep the reference
            var mergeObject = false;
            if (obj === newObj) {
                mergeObject = true;
                // Start off a clean copy of the object
                newObj = {};
            }
            // Make sure new object exists
            if (typeof newObj === 'undefined') {
                newObj = {};
            }
            // Check to see if this object is an array
            if (_this.typeOf(obj) === 'array') {
                // Store a safe copy of this object in case we are processing the b object
                var tempArray = JSON.parse(JSON.stringify(obj));
                var tempArrayLength = tempArray.length;
                // Clean up the object
                obj = {};
                // Let's see if the obj and newObj are the same.  If so, going to assume we are using the b object
                if (obj === newObj) {
                    // Let's ensure that we have the a object
                    if (typeof window.a === 'undefined') {
                        var a = 'view';
                    }
                    // Add the automatic utag data points
                    window.utag.loader.RD(newObj, window.a);
                }
                for (var i = 0; i < tempArrayLength; i++) {
                    _this.processDataObject(tempArray[i], newObj);
                }
            }
            else {
                _this.processDataObject(obj, newObj);
            }
            if (mergeObject) {
                // Need to delete everything out of obj and replace with newObj
                Object.keys(obj).forEach(function (key) {
                    delete obj[key];
                });
                // Now that we have a clean original object, add everything from newObj which allows the reference to be kept
                Object.keys(newObj).forEach(function (key) {
                    obj[key] = newObj[key];
                });
            }
            return newObj;
        };
        this.teamliumOptions = __assign({ prefix: 'ksys.', nestedDelimiter: '.', replaceKeys: {}, ignoreKeys: {} }, teamliumOptions);
    }
    return TealiumHelper;
}());
exports.TealiumHelper = TealiumHelper;
//# sourceMappingURL=TealiumHelper.js.map